import React, { useEffect, useState } from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Button as MUIButton, Stack, TextField } from "@mui/material";
import {
  Show,
  Tab,
  TabbedShowLayout,
  TabbedShowLayoutTabs,
  useRecordContext,
  useRefresh,
} from "react-admin";
import { DateTimePicker } from "@mui/x-date-pickers";
import { useNavigate } from "react-router-dom";
import ResourceSelectDialog from "../Common/ResourceSelectDialog";
import UpdateCommentInTrialDialog from "../Common/UpdateCommentInTrialDialog";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import OneMealServiceMetaShow from "./OneMealServiceMetaShow";
import { setCustomSelectOpen } from "../../store/reducers/customSelect";
import EventBus from "../../EventBus";
import { EventBusEventsEnum } from "../../enums/EventBusEventsEnum";
import { PaymentStatusEnum } from "../../enums/PaymentStatusEnum";
import { OneMealServiceStatus } from "../../enums/OneMealServiceStatus";
import { CustomSnackbarTypes } from "../Common/CustomSnackBar";
import LocalityList from "../Locality/LocalityList";
import { OneMealService } from "../../services/OneMealService";
import TrialsCancelDialog from "../Common/TrialsCancelDialog";
import RescheduleOneMealDialog from "../Common/RescheduleOneMealDialog";
import ApproveTrialsDialog from "../Common/ApproveCookToTrials";
import { PaymentLinkDailog } from "../Common/PaymentLinksDailogs";
import AdminUserList from "../AdminUser/AdminUserList";
import GroupPermissionFunction from "../../utils/groupPermissionFunction";
import { UserGroupsEnum } from "../../enums/UserGroupsEnum";
import OneMealServiceAllocationTab from "./OneMealServiceAllocationTab";
import AdminNotesForOneMeal from "../Common/AdminNotesForOneMeal";
import TrialsRefundDialog from "../Common/TrialsRefundDialog";
import OneMealVendorPayoutTab from "./OneMealVendorPayoutTab";
import AssignCookOnOneMealDialog from "../Common/AssignCookOnOneMealDialog";
import OneMealHistoryTab from "./OneMealHistoryTab";
import { OneMeal } from "../../interfaces/OneMeal/OneMeal";
import { moduleType } from "../../enums/common";
import CookDenyDialog from "../Common/CookDenyDialog";
import ChangeOmsTimeDialog from "../Common/ChangeOmsTimeDialog";
import OmsDeniedCookList from "./OmsDeniedCookList";
import RequestCookConveyanceDialog from "../Common/RequestCookConveyanceDialog";
import UpdateOMSStatusDialog from "../Common/UpdateOMSStatusDialog";
import UpdateOMSPaymentStatusDialog from "../Common/UpdateOMSPaymentStatusDialog";
import { CallMaskingReferenceModelNameEnum } from "../../enums/CallMaskingReferenceModelNameEnum";
import CustomerCallRecordingsTab from "../Customers/CustomerCallRecordingsTab";
import ServiceCallLogsTab from "../Common/ServiceCallLogsTab";
import CookServeList from "../Common/CookServeList";
import UpdateAllowedDishesDialog from "../Common/UpdateAllowedDishesDialog";
import OneMealServiceIngredientList from "./OneMealServiceIngredientList";
import AddIngredientDialogOms from "../Common/AddIngredientDialogOms";
import CookAdditionalDetails from "../Cooks/CookAdditionalDetails";
import CookAuditLogs from "../Cooks/CookAuditLogs";
import moment from "moment";
import ReferenceSosAlertsTable from "../Common/ReferenceSosAlertsTable";
import ServiceRefundsTab from "../Common/ServiceRefundsTab";
import ServiceNotificationsTab from "../Common/ServiceNotificationsTab";
import { ImportantVisitContext } from "./ImportantVisitContext";
import TimeExtensionDialog from "./TimeExtensionDialog";
import OneMealTimeExtensionTab from "./OneMealTimeExtensionTab";

import { CookService } from "../../services/CookServices";
import HorizontalTimeline from "../Common/HorizontalTimeline";
import CookIncentiveDialog from "../Common/CookIncentiveDialog";

const oneMealService = new OneMealService();
const cookService = new CookService();

const TopTimeline = () => {
  const record = useRecordContext();
  return (
    <Box
      sx={{
        background: "#fff",
        border: "1px solid #e8ebed",
        borderRadius: "12px",
        padding: "16px 20px",
        marginBottom: "16px",
        marginLeft: "8px",
      }}
    >
      <HorizontalTimeline record={record} />
    </Box>
  );
};

interface InputProps {
  name: any;
  callback: (data: any) => void;
  color?:
    | "inherit"
    | "primary"
    | "secondary"
    | "error"
    | "info"
    | "success"
    | "warning"
    | undefined;
}

export const CustomButton = (props: InputProps) => {
  let record = useRecordContext()

  return (
    <MUIButton
      onClick={(e) => {
        e.stopPropagation()
        props.callback(record);
      }}
      size={"small"}
      color={props.color || "secondary"}
      variant={"contained"}
       sx={{
        fontSize: "12px",
      }}
    >
      {props.name}
    </MUIButton>
  );
};

export const ActionButtons = (props: any) => {
  const record = useRecordContext();
  const refresh = useRefresh();
  const userDetails = useAppSelector((state) => state.userDetails.value);
  let groupsArray: string[] = userDetails.adminUser.accessGroups;
  const [openArrivalDialog, setOpenArrivalDialog] = useState(false);
  const [arrivalTime, setArrivalTime] = useState<any>(null);
  const [openAgentEtaDialog, setOpenAgentEtaDialog] = useState(false);
  const [agentEtaTime, setAgentEtaTime] = useState<any>(moment());
  const [openCheckInTimeDialog, setOpenCheckInTimeDialog] = useState(false);
  const [checkInTime, setCheckInTime] = useState<any>(moment());
  const [checkInTimeSubmitting, setCheckInTimeSubmitting] = useState(false);
  const [openLunchMoneyDialog, setOpenLunchMoneyDialog] = useState(false);
  const [openFarVisitIncentiveDialog, setOpenFarVisitIncentiveDialog] = useState(false);
  const [openTimeExtensionDialog, setOpenTimeExtensionDialog] = useState(false);

  const { isImportant, setIsImportant } = props;

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (record?.cookArrivalTime) {
      setArrivalTime(moment(record.cookArrivalTime));
    } else {
      setArrivalTime(moment());
    }
  }, [record?.cookArrivalTime]);

  const navigate = useNavigate();
  const handleFixSlcOpen = () => {
    dispatch(
      setCustomSelectOpen({
        open: true,
      })
    );
  };

  const onClickSendPaymentLink = () => {
    EventBus.emitEvent(EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG, {
      message: "Are you sure you want to send the payment link?",
      onClose: (confirmed: boolean) => {
        if (confirmed) {
          oneMealService
            .sendOneMealPaymentLink(parseInt((record as any)?.id))
            .then((res) => {
              props.setPaymentDialog(true);
              props.setPaymentLinks(res);
              EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                message: "Payment link sent",
                type: CustomSnackbarTypes.SUCCESS,
              });
            });
        }
      },
      title: "Confirmation",
    });
  };

  return (
    <div>
      <Stack direction={"row"} style={{ marginBottom: "10px", marginLeft: "8px" }} gap={2}>
        {[
          OneMealServiceStatus.PENDING,
          OneMealServiceStatus.COOK_ALLOCATED,
          OneMealServiceStatus.COOK_CONFIRMED,
        ].includes(record?.status) && (
            <CustomButton
              name={record?.cookId ? "Change Cook" : "Assign Cook"}
              color={"primary"}
              callback={(data) => {
                props.setSelectedData(data);
                props.setOpenAssignCookDialog(true);
                props.setInitiatedBy(2);
              }}
            />
          )}
          {
            GroupPermissionFunction(groupsArray, [
              UserGroupsEnum.ADMIN,
            ]) && (record?.status !== OneMealServiceStatus.FULFILLED) && (
              <CustomButton
              name={"Change OMS Time"}
              color="primary"
              callback={(data: any) => {
                props.setSelectedData(data);
                props.setOneMealTimeUpdateDialog(true);
              }}
            />
            )
          }
        {[
          OneMealServiceStatus.PENDING,
          OneMealServiceStatus.COOK_ALLOCATED,
          OneMealServiceStatus.COOK_CONFIRMED,
          OneMealServiceStatus.ONGOING,
        ].includes(record?.status) && (
          <CustomButton
            name={"Cancel One Meal"}
            color="error"
            callback={(data: any) => {
              props.setSelectedData(data);
              props.setCancelTrialModel(true);
              props.setInitiatedBy(2);
            }}
          />
        )}
        {[
          OneMealServiceStatus.PENDING,
          OneMealServiceStatus.COOK_ALLOCATED,
          OneMealServiceStatus.COOK_CONFIRMED,
        ].includes(record?.status) && (
            <CustomButton
              name={"Reschedule One Meal"}
              color="primary"
              callback={(data: any) => {
                props.setSelectedData(data);
                props.setRescheduleModel(true);
              }}
            />
          )}
        {[OneMealServiceStatus.COOK_ALLOCATED].includes(record?.status) && (
          <CustomButton
            name={"Action By Cook"}
            color="success"
            callback={(data: any) => {
              props.setSelectedData(data);
              props.setApprovalModel(true);
              props.setInitiatedBy(2);
            }}
          />
        )}
        {[OneMealServiceStatus.COOK_CONFIRMED].includes(record?.status) && (
          <CustomButton
            name={"Mark as Ongoing"}
            color="primary"
            callback={(data: any) => {
              oneMealService
                .markAsOngoingForOneMeal(parseInt((record as any)?.id))
                .then((res) => {
                  EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                    message: "Success",
                    type: CustomSnackbarTypes.SUCCESS,
                  });
                  refresh();
                });
            }}
          />
        )}
        {[
          OneMealServiceStatus.COOK_CONFIRMED,
          OneMealServiceStatus.ONGOING,
        ].includes(record?.status) && (
          <CustomButton
            name={"Mark as Fulfilled"}
            color="primary"
            callback={() => {
              EventBus.emitEvent(EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG, {
                message: "Are you sure you want to mark the meal fulfilled?",
                onClose: (confirmed: boolean) => {
                  if (confirmed) {
                    oneMealService
                      .markAsFulfiledForOneMeal(parseInt((record as any)?.id))
                      .then((res) => {
                        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                          message: "One Meal marked fulfilled",
                          type: CustomSnackbarTypes.SUCCESS,
                        });
                        refresh();
                      });
                  }
                },
                title: "Confirmation",
              });
            }}
          />
        )}
        <CustomButton
            name={(record as any)?.allowLateCheckIn ? "Remove Late Checkin" : "Allow Late Checkin"}
            color="error"
            callback={() => {
              EventBus.emitEvent(EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG, {
                message: (record as any)?.allowLateCheckIn ? "Are you sure you want to remove late checkin?" : "Are you sure you want to allow late checkin?",
                onClose: (confirmed: boolean) => {
                  if (confirmed) {
                    oneMealService
                      .allowLateCheckin(parseInt((record as any)?.id))
                      .then((res) => {
                        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                          message: "Allowed late checkin",
                          type: CustomSnackbarTypes.SUCCESS,
                        });
                        refresh();
                      });
                  }
                },
                title: "Confirmation",
              });
            }}
          />
        <CustomButton
          name={"Add Admin Notes"}
          color="primary"
          callback={(data: any) => {
            props.setSelectedData(data);
            props.setOpenSetAdminNotesDialog(true);
          }}
        />
        <CustomButton
          name={"Update Meal Owner"}
          color="primary"
          callback={(data: any) => {
            props.setOpenUpdateMealOwner(true);
            props.getData(record);
            props.setIsForOneMealOwner(true);
            props.handleClickOpen();
          }}
        />
        <CustomButton
          name={"Change Allowed Dishes"}
          color="primary"
          callback={(data: any) => {
            props.setUpdateAllowedDishes(true);
          }}
        />
        {GroupPermissionFunction(groupsArray, [
          UserGroupsEnum.ADMIN,
          UserGroupsEnum.MANAGER,
        ]) && (
          <CustomButton
            name={"Update Meal Allocator"}
            color="primary"
            callback={(data: any) => {
              props.setOpenUpdateOneMealAllocator(true);
              props.getData(record);
              props.setIsForOneMealOwner(false);
              props.handleClickOpen();
            }}
          />
        )}
        {record?.areaId === null && (
          <CustomButton
            name={"Fix SLC"}
            color="primary"
            callback={(data: any) => {
              handleFixSlcOpen();
              props.setOpenFixSLC(true);
            }}
          />
        )}
        {record?.paymentStatus === PaymentStatusEnum.PAID && (
          <CustomButton
            name={"Refund Meal Amount"}
            color="error"
            callback={(data: any) => {
              props.setInitiatedBy(2);
              props.setSelectedData(data);
              props.setRefundOneMealModel(true);
            }}
          />
        )}
        {![OneMealServiceStatus.CANCELLED].includes(record?.status) &&
          record?.paymentStatus === PaymentStatusEnum.NOT_PAID && (
            <Button
              color="primary"
              variant={"contained"}
              onClick={onClickSendPaymentLink}
            >
              {"Send Payment Link"}
            </Button>
          )}
        {[OneMealServiceStatus.COOK_CONFIRMED].includes(record?.status) && (
          <CustomButton
            name={"Cook Deny"}
            color={"error"}
            callback={(data) => {
              props.setSelectedData(data);
              props.setOpenCookDenyDialog(true);
            }}
          />
        )}
        {[OneMealServiceStatus.COOK_CONFIRMED].includes(record?.status) && (
          <CustomButton
            name={"Remove Cook"}
            color={"error"}
            callback={(data) => {
              EventBus.emitEvent(EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG, {
                message: "Are you sure you want to remove the cook?",
                onClose: (confirmed: boolean) => {
                    if (confirmed) {
                        oneMealService
                            .removeCook(parseInt((record as any)?.id))
                            .then((res) => {
                                EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                                    message: "Success",
                                    type: CustomSnackbarTypes.SUCCESS,
                                });
                                refresh();
                            });
                    }
                },
            });
            }}
          />
        )}
          {[OneMealServiceStatus.FULFILLED].includes(record?.status) &&
            <Button
              color="primary"
              variant={"contained"}
              onClick={() => {
                  EventBus.emitEvent(EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG, {
                      message: "Are you sure you want to penalize?",
                      onClose: (confirmed: boolean) => {
                          if (confirmed) {
                              oneMealService
                                  .penalizeCookForNotWearingTShirt(parseInt((record as any)?.id))
                                  .then((res) => {
                                      EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                                          message: "Success",
                                          type: CustomSnackbarTypes.SUCCESS,
                                      });
                                      refresh();
                                  });
                          }
                      },
                  });
              }}
            >
                {"Penalize for no t-shirt"}
            </Button>
          }
      </Stack>
      <Stack direction={"row"} style={{ marginBottom: "10px", marginLeft: "8px" }} gap={2}>
        {(record?.hasOptedPayAfterService || [
          PaymentStatusEnum.PAID,
          PaymentStatusEnum.PAYMENT_IN_PROGRESS,
          PaymentStatusEnum.REFUND_IN_PROGRESS,
          PaymentStatusEnum.REFUNDED,
          PaymentStatusEnum.REFUND_FAILED,
        ].includes(record?.paymentStatus)) && (
            <>
              <Button 
                onClick={() => {
                  navigate(`/VisitTracker/ONE_MEAL_SERVICE/${record?.id}/${record.cookId}`, {
                    state: { visitData: record },
                  });
                }}
                variant="contained"
                color="success"
                sx={{width: 'auto', fontSize: '12px'}}
              >
                View Tracker
              </Button>
              {record?.isConveyanceAllowed &&
                [OneMealServiceStatus.FULFILLED, OneMealServiceStatus.CANCELLED].includes(record?.status) &&
                <CustomButton
                  name={"Request Cook Conveyance"}
                  color="primary"
                  callback={(data) => {
                    props.setSelectedData(data);
                    props.setRequestCookConveyanceDialog(true);
                  }}
                />
              }
              <CustomButton
                  name={"Support Comments"}
                  color="primary"
                  callback={() => {
                    props.setUpdateCommentDialog(true);
                    props.setInitiatedBy(5);
                  }}
              />
              <CustomButton
                  name={"CX Feedback"}
                  color="primary"
                  callback={() => {
                    props.setUpdateCommentDialog(true);
                    props.setInitiatedBy(6);
                  }}
              />
              <CustomButton
                  name={"Chef Feedback"}
                  color="primary"
                  callback={() => {
                    props.setUpdateCommentDialog(true);
                    props.setInitiatedBy(7);
                  }}
              />
              <CustomButton
                  name={"Allocation Comments"}
                  color="primary"
                  callback={() => {
                    props.setUpdateCommentDialog(true);
                    props.setInitiatedBy(8);
                  }}
              />
              <CustomButton
                  name={"Time Extension"}
                  color="primary"
                  callback={() => setOpenTimeExtensionDialog(true)}
              />
              <TimeExtensionDialog
                open={openTimeExtensionDialog}
                onClose={() => setOpenTimeExtensionDialog(false)}
              />
              {(record?.status !== OneMealServiceStatus.CANCELLED&&record?.status !== OneMealServiceStatus.FULFILLED&&!record?.preCheckedInAt)&&<CustomButton
                  name={"Pre Checkin"}
                  color="primary"
                  callback={() => {
                    EventBus.emitEvent(EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG, {
                      message: "Confirm Pre Checkin",
                      onClose: (confirmed: boolean) => {
                        if(confirmed){
                        oneMealService.preCheckIn(Number(record?.cookId),Number(record?.id)).then((data)=>{
                          EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                            message: "Pre Checkin Successful",
                            type: CustomSnackbarTypes.SUCCESS,
                          });
                          refresh();
                        }).catch(error=>{
                          console.log(error);
                        })
                      }
                      },
                      title: "Confirmation",
                  });

                  }}
                />

              }

              {
          !record?.isCashCollected
                &&record?.paymentStatus!=="PAID"&&
                <CustomButton
                  name={"Cash Collected"}
                  color="primary"
                  callback={() => {
                    EventBus.emitEvent(EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG, {
                      message: "Confirm Cash Collected",
                      onClose: (confirmed: boolean) => {
                        oneMealService.cashCollected(Number(record?.id)).then((data)=>{
                          EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                            message: "Cash collected successfully",
                            type: CustomSnackbarTypes.SUCCESS,
                          });
                          refresh();
                        }).catch(error=>{
                          console.log(error);
                        })

                      },
                  });

                  }}
                />
          }
            </>

        )}
      </Stack>
      <Stack direction={"row"} style={{ marginBottom: "10px", marginLeft: "8px" }} gap={2}>
        {GroupPermissionFunction(groupsArray, [
                UserGroupsEnum.ADMIN,
              ]) && (
                <CustomButton
                  name={"Update OMS Status"}
                  color="primary"
                  callback={() => {
                    props.setUpdateOMSStatusDialog(true);
                  }}
                />
              )}
              {GroupPermissionFunction(groupsArray, [
                UserGroupsEnum.ADMIN,
              ]) && (
                <CustomButton
                  name={"Update OMS Payment Status"}
                  color="primary"
                  callback={() => {
                    props.setUpdateOMSPaymentStatusDialog(true);
                  }}
                />
              )}
              <CustomButton
                name={"Add Ingredient"}
                color="success"
                callback={(data: any) => {
                  props.setSelectedData(data);
                  props.setAddIngredientModel(true);
                }}
              />

              <CustomButton
                name={"Update Instant Chefit ETA"}
                color="primary"
                callback={() => setOpenArrivalDialog(true)}
              />

              <CustomButton
                name={"Update Agent Expected ETA"}
                color="primary"
                callback={() => setOpenAgentEtaDialog(true)}
              />

              <CustomButton
                name={"Update Check In Time ETA"}
                color="primary"
                callback={() => setOpenCheckInTimeDialog(true)}
              />

              {GroupPermissionFunction(groupsArray, [
                UserGroupsEnum.ADMIN,
                UserGroupsEnum.MANAGER,
              ]) && (
                <>
                  <CustomButton
                    name={"Lunch Money"}
                    color="success"
                    callback={() => setOpenLunchMoneyDialog(true)}
                  />
                  <CustomButton
                    name={"Far Visit Incentive"}
                    color="success"
                    callback={() => setOpenFarVisitIncentiveDialog(true)}
                  />
                </>
              )}

              <CookIncentiveDialog
                open={openLunchMoneyDialog}
                id={parseInt((record as any)?.id)}
                serviceType={"oneMeal"}
                incentiveType={"lunchMoney"}
                callback={() => {
                  setOpenLunchMoneyDialog(false);
                  refresh();
                }}
              />

              <CookIncentiveDialog
                open={openFarVisitIncentiveDialog}
                id={parseInt((record as any)?.id)}
                serviceType={"oneMeal"}
                incentiveType={"farVisitIncentive"}
                callback={() => {
                  setOpenFarVisitIncentiveDialog(false);
                  refresh();
                }}
              />

              <Dialog
                open={openArrivalDialog}
                onClose={() => setOpenArrivalDialog(false)}
                maxWidth="xs"
                fullWidth
              >
                <DialogTitle>Update Instant Chefit Arrival Time</DialogTitle>

                <DialogContent>
                  <Stack spacing={2} mt={1}>
                    <DateTimePicker
                      value={arrivalTime}
                      onChange={(newValue) => setArrivalTime(newValue)}
                      onAccept={(newValue) => setArrivalTime(newValue)}
                      views={["hours", "minutes"]}
                      openTo="hours"
                      disablePast
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          inputProps={{
                            ...params.inputProps,
                            value: arrivalTime
                              ? moment(arrivalTime).format("MM/DD/YYYY hh:mm A")
                              : (params.inputProps?.value || ""),
                          }}
                        />
                      )}
                    />
                  </Stack>
                </DialogContent>

                <DialogActions>
                  <Button
                    onClick={() => setOpenArrivalDialog(false)}
                    color="secondary"
                  >
                    Cancel
                  </Button>

                  <Button
                    variant="contained"
                    color="primary"
                    onClick={async () => {
                      if (!arrivalTime || !record?.id) {
                        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                          message: "Please select a valid date & time",
                          type: CustomSnackbarTypes.ERROR,
                        });
                        return;
                      }

                      try {
                        await oneMealService.updateCookArrivalTime(
                          Number(record.id),
                          moment(arrivalTime).format("YYYY-MM-DD hh:mm A")
                        );

                        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                          message: "Cook arrival time updated successfully",
                          type: CustomSnackbarTypes.SUCCESS,
                        });

                        setOpenArrivalDialog(false);
                        refresh();
                      } catch (err: any) {
                        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                          message: err?.response?.data?.error || err?.response?.data?.message || "Failed to update cook arrival time",
                          type: CustomSnackbarTypes.ERROR,
                        });
                      }
                    }}
                  >
                    Update
                  </Button>
                </DialogActions>
              </Dialog>

              <Dialog
                open={openAgentEtaDialog}
                onClose={() => setOpenAgentEtaDialog(false)}
                maxWidth="xs"
                fullWidth
              >
                <DialogTitle>Update Agent Expected Arrival Time</DialogTitle>

                <DialogContent>
                  <Stack spacing={2} mt={1}>
                    <DateTimePicker
                      value={agentEtaTime}
                      onChange={(newValue) => setAgentEtaTime(newValue)}
                      onAccept={(newValue) => setAgentEtaTime(newValue)}
                      views={["hours", "minutes"]}
                      openTo="hours"
                      disablePast
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          inputProps={{
                            ...params.inputProps,
                            value: agentEtaTime
                              ? moment(agentEtaTime).format("MM/DD/YYYY hh:mm A")
                              : (params.inputProps?.value || ""),
                          }}
                        />
                      )}
                    />
                  </Stack>
                </DialogContent>

                <DialogActions>
                  <Button
                    onClick={() => setOpenAgentEtaDialog(false)}
                    color="secondary"
                  >
                    Cancel
                  </Button>

                  <Button
                    variant="contained"
                    color="primary"
                    onClick={async () => {
                      if (!agentEtaTime || !record?.id) {
                        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                          message: "Please select a valid date & time",
                          type: CustomSnackbarTypes.ERROR,
                        });
                        return;
                      }

                      try {
                        await oneMealService.updateAgentEta(
                          Number(record.id),
                          moment(agentEtaTime).toISOString()
                        );

                        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                          message: "Agent expected arrival time updated successfully",
                          type: CustomSnackbarTypes.SUCCESS,
                        });

                        setOpenAgentEtaDialog(false);
                        refresh();
                      } catch (err: any) {
                        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                          message: err?.response?.data?.error || err?.response?.data?.message || "Failed to update agent expected arrival time",
                          type: CustomSnackbarTypes.ERROR,
                        });
                      }
                    }}
                  >
                    Update
                  </Button>
                </DialogActions>
              </Dialog>

              <Dialog
                open={openCheckInTimeDialog}
                onClose={() => setOpenCheckInTimeDialog(false)}
                maxWidth="xs"
                fullWidth
              >
                <DialogTitle>Update Check In Time ETA</DialogTitle>

                <DialogContent>
                  <Stack spacing={2} mt={1}>
                    <DateTimePicker
                      value={checkInTime}
                      onChange={(newValue) => setCheckInTime(newValue)}
                      onAccept={(newValue) => setCheckInTime(newValue)}
                      views={["hours", "minutes"]}
                      openTo="hours"
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          inputProps={{
                            ...params.inputProps,
                            value: checkInTime
                              ? moment(checkInTime).format("MM/DD/YYYY hh:mm A")
                              : (params.inputProps?.value || ""),
                          }}
                        />
                      )}
                    />
                  </Stack>
                </DialogContent>

                <DialogActions>
                  <Button
                    onClick={() => setOpenCheckInTimeDialog(false)}
                    color="secondary"
                    disabled={checkInTimeSubmitting}
                  >
                    Cancel
                  </Button>

                  <Button
                    variant="contained"
                    color="primary"
                    disabled={checkInTimeSubmitting}
                    onClick={async () => {
                      if (!checkInTime || !record?.id) {
                        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                          message: "Please select a valid date & time",
                          type: CustomSnackbarTypes.ERROR,
                        });
                        return;
                      }

                      setCheckInTimeSubmitting(true);
                      try {
                        await oneMealService.updateCheckInTime(
                          Number(record.id),
                          moment(checkInTime).format("YYYY-MM-DD HH:mm:ss")
                        );

                        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                          message: "Check in time updated successfully",
                          type: CustomSnackbarTypes.SUCCESS,
                        });

                        setOpenCheckInTimeDialog(false);
                        refresh();
                      } catch (err: any) {
                        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                          message: err?.response?.data?.error || err?.response?.data?.message || "Failed to update check in time",
                          type: CustomSnackbarTypes.ERROR,
                        });
                      } finally {
                        setCheckInTimeSubmitting(false);
                      }
                    }}
                  >
                    {checkInTimeSubmitting ? "Updating..." : "Update"}
                  </Button>
                </DialogActions>
              </Dialog>
        <CustomButton
          name={isImportant ? "Unmark Important" : "Mark Important"}
          color={isImportant ? "warning" : "inherit"}
          callback={() => {
            cookService
              .markVisitAsImportant(Number(record?.id), "ONE_MEAL_SERVICE", !isImportant)
              .then(() => {
                const next = !isImportant;
                setIsImportant(next);
                EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                  message: next ? "Marked as important" : "Removed from important",
                  type: CustomSnackbarTypes.SUCCESS,
                });
                refresh();
              })
              .catch(() => {
                EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                  message: "Failed to update importance",
                  type: CustomSnackbarTypes.ERROR,
                });
              });
          }}
        />
        {GroupPermissionFunction(groupsArray, [UserGroupsEnum.ADMIN]) && (
          <CustomButton
            name={"Remove Customer Rating"}
            color="error"
            callback={(data: any) => {
              const ratingId = data?.customerRatings?.[0]?.id;
              if (!ratingId) {
                EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                  message: "No customer rating found for this visit",
                  type: CustomSnackbarTypes.ERROR,
                });
                return;
              }
              EventBus.emitEvent(EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG, {
                message: "Are you sure you want to remove the customer rating?",
                onClose: (confirmed: boolean) => {
                  if (confirmed) {
                    cookService.deleteCookRating(ratingId).then(() => {
                      EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                        message: "Customer rating removed successfully",
                        type: CustomSnackbarTypes.SUCCESS,
                      });
                      refresh();
                    }).catch(() => {
                      EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                        message: "Failed to remove customer rating",
                        type: CustomSnackbarTypes.ERROR,
                      });
                    });
                  }
                },
                title: "Confirmation",
              });
            }}
          />
        )}
      </Stack>
    </div>
  );
};

const OneMealServiceTabs = () => {
  let location = useLocation();
  let oneMealServiceId = location.pathname.split("/")[2];
  const recode: OneMeal = useRecordContext();


  return (
    <TabbedShowLayout tabs={<TabbedShowLayoutTabs variant="scrollable" scrollButtons="auto" selectionFollowsFocus={true} />}>
      <Tab label={"Details"} key={"Details"}>
        <OneMealServiceMetaShow />
      </Tab>
      <Tab label={"Cook Serve List"} key={"Cook Serve List"}>
        <CookServeList
            serviceId={1}
            referenceId={recode?.areaId}
            time={recode?.time}
            totalPeople={recode?.totalPeople}
            slotSize={recode?.slotSize}
            date={recode?.date}
            hasService={true}
            mealServiceId={Number(oneMealServiceId)}
            houseId={recode?.houseId}
            type={"OMS"}
        />
      </Tab>
      <Tab label={"Sos Alerts"} key={"Sos Alerts"}>
        <ReferenceSosAlertsTable referenceId={Number(oneMealServiceId)} referenceModel="ONE_MEAL_SERVICE"/>
      </Tab>
      <Tab label={"Ingredient List"} key={"IngredientList"}>
        <OneMealServiceIngredientList ingredientList = {recode?.ingredientList}/>
      </Tab>
      <Tab label={"Allocation Tab"} key={"Allocation Tab"}>
        <OneMealServiceAllocationTab
          oneMealServiceId={Number(oneMealServiceId)}
        />
      </Tab>
      <Tab label={"Time Extensions"} key={"Time Extensions"}>
        <OneMealTimeExtensionTab />
      </Tab>
      <Tab label={"Vendor Payout Tab"} key={"Vendor Payout Tab"}>
        <OneMealVendorPayoutTab oneMealServiceId={Number(oneMealServiceId)} />
      </Tab>
      <Tab label={"History Tab"} key={"History Tab"}>
        <OneMealHistoryTab houseId={Number(recode?.house?.id)} />
      </Tab>
      <Tab label={"Denied Cooks"} key={"Denied Cooks"}>
        <OmsDeniedCookList serviceId={Number(oneMealServiceId)} />
      </Tab>
      <Tab label={"Call Recordings"} key={"Call Recordings"}>
        <CustomerCallRecordingsTab serviceId={Number(recode?.id)} referenceModalName={CallMaskingReferenceModelNameEnum.ONE_MEAL_SERVICE}/>
      </Tab>
      <Tab label={"Call Logs"} key={"Call Logs"}>
        <ServiceCallLogsTab referenceId={Number(oneMealServiceId)} referenceModelName={"ONE_MEAL_SERVICE"} />
      </Tab>
      <Tab label={"Customer Extra Details"}>
        <CookAdditionalDetails partyId={Number(recode?.house?.customers[0]?.id)} referenceModel='CUSTOMER_MODEL'/>
      </Tab>
      <Tab label={"Audit Logs"}>
        <CookAuditLogs referenceId={Number(oneMealServiceId)} referenceModel="Oms"/>
      </Tab>
      <Tab label={"Refunds"}>
        <ServiceRefundsTab referenceId={Number(oneMealServiceId)} referenceModel="ONE_MEAL_SERVICE" />
      </Tab>
      <Tab label={"Notifications"} key={"Notifications"}>
        <ServiceNotificationsTab referenceId={Number(oneMealServiceId)} referenceModelName="ONE_MEAL_SERVICE" />
      </Tab>
    </TabbedShowLayout>
  );
};

const InnerShowContent = (props: any) => {
  const record = useRecordContext();
  const [isImportant, setIsImportant] = useState<boolean>(!!record?.isImportant);

  useEffect(() => {
    setIsImportant(!!record?.isImportant);
  }, [record?.isImportant]);

  return (
    <ImportantVisitContext.Provider value={isImportant}>
      <TopTimeline />
      <ActionButtons isImportant={isImportant} setIsImportant={setIsImportant} {...props} />
      <OneMealServiceTabs />
    </ImportantVisitContext.Provider>
  );
};

const OneMealServiceShow = (props: any) => {
  const refresh = useRefresh();
  const dispatch = useAppDispatch();
  let [selectedData, setSelectedData] = useState<any>(null);
  const [openFixSLC, setOpenFixSLC] = useState(false);
  const [updateCommentDialog, setUpdateCommentDialog] = useState(false);
  let [rescheduleModel, setRescheduleModel] = useState<boolean>(false);
  let [cancelTrialModel, setCancelTrialModel] = useState<boolean>(false);
  const [openAssignCookDialog, setOpenAssignCookDialog] = useState(false);
  const [initiatedBy, setInitiatedBy] = useState<any>();
  let [approvalModel, setApprovalModel] = useState<boolean>(false);
  let [paymentDialog, setPaymentDialog] = useState<boolean>(false);
  let [paymentLinks, setPaymentLinks] = useState();
  const [openSetAdminNotesDialog, setOpenSetAdminNotesDialog] = useState(false);
  let [isForOneMealOwner, setIsForOneMealOwner] = useState<boolean>(false);
  const [openUpdateMealOwner, setOpenUpdateMealOwner] = useState(false);
  let [refundOneMealModel, setRefundOneMealModel] = useState<boolean>(false);
  const [openCookDenyDialog, setOpenCookDenyDialog] = useState<boolean>(false);
  const [openUpdateOneMealAllocator, setOpenUpdateOneMealAllocator] =
    useState(false);
  const [oneMealTimeUpdateDialog, setOneMealTimeUpdateDialog] = useState<boolean>(false);
  const [oneMealId, setOneMealId] = useState<any>();
  const [requestCookConveyanceDialog, setRequestCookConveyanceDialog] = useState<boolean>(false);
  const [updateOMSStatusDialog, setUpdateOMSStatusDialog] = useState<boolean>(false);
  const [updateOMSPaymentStatusDialog, setUpdateOMSPaymentStatusDialog] = useState<boolean>(false);
  const [updateAllowedDishes, setUpdateAllowedDishes] = useState<boolean>(false);
  const [addIngredientModel, setAddIngredientModel] = useState(false);
  let location = useLocation();
  let oneMealServiceId = location.pathname.split("/")[2];

  const handleSelectCookOrAdminUser = () => {
    dispatch(
      setCustomSelectOpen({
        open: true,
      })
    );
  };

  const getData = (data: any) => {
    setOneMealId(data);
  };

  const handleClickOpen = () => {
    handleSelectCookOrAdminUser();
  };

  const handleAdminUserAfterSelect = (data: any) => {
    setOpenUpdateMealOwner(false);
    setOpenUpdateOneMealAllocator(false);
    setOpenUpdateMealOwner(false);
    if (isForOneMealOwner) {
      handleSelectAdminUserForTrialOwner(data);
    } else if (!isForOneMealOwner) {
      handleSelectAdminUserForTrialAllocator(data);
    }
    return;
  };

  const handleSelectAdminUserForTrialOwner = (data: any) => {
    if (!data) {
      return;
    }
    oneMealService
      .changeOneMealOwner(oneMealId?.id, { ownerId: data?.id })
      .then(() => {
        refresh();
        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
          message: `One Meal Owner Updated Successfully`,
          type: CustomSnackbarTypes.SUCCESS,
        });
      })
      .catch(() => {
        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
          message: `One Meal Owner was not updated `,
          type: CustomSnackbarTypes.ERROR,
        });
      });
  };

  const handleSelectAdminUserForTrialAllocator = (data: any) => {
    if (!data) {
      return;
    }
    oneMealService
      .changeCookAllocator(oneMealId?.id, { allocatorId: data?.id })
      .then(() => {
        refresh();
        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
          message: `One Meal Allocator Updated Successfully`,
          type: CustomSnackbarTypes.SUCCESS,
        });
      })
      .catch(() => {
        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
          message: `One Meal Allocator Was not Updated`,
          type: CustomSnackbarTypes.ERROR,
        });
      });
  };

  const handleFixSLC = (recordData: any) => {
    setOpenFixSLC(false);
    oneMealService
      .patchLocality(Number(oneMealServiceId), {
        localityId: recordData?.id,
        cityId: recordData?.cityId,
        areaId: recordData?.areaId,
      })
      .then(() => {
        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
          message: "success",
          type: CustomSnackbarTypes.SUCCESS,
        });
        refresh();
      })
      .catch(() => {
        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
          message: "Error",
          type: CustomSnackbarTypes.ERROR,
        });
      });
  };
  return (
    <Show {...props} actions={false}>
      <div>
        <ChangeOmsTimeDialog open={oneMealTimeUpdateDialog} setOpen={setOneMealTimeUpdateDialog} data={selectedData} />
        {refundOneMealModel && <TrialsRefundDialog
          initiatedBy={initiatedBy}
          data={selectedData}
          open={refundOneMealModel}
          callback={() => {
            setRefundOneMealModel(false);
          }}
        />}
        <AdminNotesForOneMeal
          data={selectedData}
          open={openSetAdminNotesDialog}
          setOpen={setOpenSetAdminNotesDialog}
        />
        {openUpdateMealOwner && (
          <ResourceSelectDialog
            name={"AdminUsers"}
            list={AdminUserList}
            onClose={handleAdminUserAfterSelect}
          />
        )}
        {openUpdateMealOwner && (
          <ResourceSelectDialog
            name={"AdminUsers"}
            list={AdminUserList}
            onClose={handleAdminUserAfterSelect}
          />
        )}
        {openUpdateOneMealAllocator && (
          <ResourceSelectDialog
            name={"AdminUsers"}
            list={AdminUserList}
            onClose={handleAdminUserAfterSelect}
          />
        )}
        <PaymentLinkDailog
          data={paymentLinks}
          open={paymentDialog}
          callback={() => {
            setPaymentDialog(false);
          }}
        />
        <ApproveTrialsDialog
          initiatedBy={initiatedBy}
          data={selectedData}
          open={approvalModel}
          callback={() => {
            setApprovalModel(false);
          }}
        />
        {rescheduleModel && <RescheduleOneMealDialog
          data={selectedData}
          open={rescheduleModel}
          callback={() => {
            setRescheduleModel(false);
          }}
        />}
        <AssignCookOnOneMealDialog
          data={selectedData}
          open={openAssignCookDialog}
          setOpen={setOpenAssignCookDialog}
          id={oneMealServiceId}
        />
        {cancelTrialModel && <TrialsCancelDialog
          intiatedBy={initiatedBy}
          data={selectedData}
          open={cancelTrialModel}
          callback={() => {
            setCancelTrialModel(false);
          }}
        />}
        {openFixSLC && (
          <ResourceSelectDialog
            name={"Localities"}
            list={LocalityList}
            onClose={handleFixSLC}
          />
        )}
        <UpdateCommentInTrialDialog
          initiatedBy={initiatedBy}
          open={updateCommentDialog}
          setOpen={setUpdateCommentDialog}
        />
        <UpdateOMSStatusDialog
          open={updateOMSStatusDialog}
          setOpen={setUpdateOMSStatusDialog}
        />
        <UpdateOMSPaymentStatusDialog
          open={updateOMSPaymentStatusDialog}
          setOpen={setUpdateOMSPaymentStatusDialog}
        />
        {openCookDenyDialog && (
          <CookDenyDialog
            open={openCookDenyDialog}
            setOpen={setOpenCookDenyDialog}
            data={selectedData}
            requestFrom={moduleType.ONE_MEAL_SERVICE}
          />
        )}
        {requestCookConveyanceDialog && (
          <RequestCookConveyanceDialog
            open={requestCookConveyanceDialog}
            setOpen={setRequestCookConveyanceDialog}
            data={selectedData}
          />
        )}
        {updateAllowedDishes && (
          <UpdateAllowedDishesDialog
            open={updateAllowedDishes}
            setOpen={setUpdateAllowedDishes}
          />
        )}
        {
          addIngredientModel && 
          <AddIngredientDialogOms
            open={addIngredientModel}
            callback={() => setAddIngredientModel(false)}
            data={selectedData}
          />
        }
        <Show {...props} actions={false}>
          <InnerShowContent
            handleClickOpen={handleClickOpen}
            setCancelTrialModel={setCancelTrialModel}
            setRefundOneMealModel={setRefundOneMealModel}
            setRescheduleModel={setRescheduleModel}
            setApprovalModel={setApprovalModel}
            setSelectedData={setSelectedData}
            getData={getData}
            setIsForOneMealOwner={setIsForOneMealOwner}
            setOpenSetAdminNotesDialog={setOpenSetAdminNotesDialog}
            setOpenAssignCookDialog={setOpenAssignCookDialog}
            setOpenFixSLC={setOpenFixSLC}
            setOpenUpdateOneMealAllocator={setOpenUpdateOneMealAllocator}
            setOpenUpdateMealOwner={setOpenUpdateMealOwner}
            setPaymentDialog={setPaymentDialog}
            setPaymentLinks={setPaymentLinks}
            setUpdateCommentDialog={setUpdateCommentDialog}
            setUpdateOMSStatusDialog={setUpdateOMSStatusDialog}
            setUpdateOMSPaymentStatusDialog={setUpdateOMSPaymentStatusDialog}
            setInitiatedBy={setInitiatedBy}
            setOpenCookDenyDialog={setOpenCookDenyDialog}
            setOneMealTimeUpdateDialog={setOneMealTimeUpdateDialog}
            setRequestCookConveyanceDialog={setRequestCookConveyanceDialog}
            setUpdateAllowedDishes={setUpdateAllowedDishes}
            setAddIngredientModel={setAddIngredientModel}
          />
        </Show>
      </div>
    </Show>
  );
};

export default OneMealServiceShow;
